import { getPointsDisplayMode } from './getPointsDisplayMode';
import { MultiplePointsDisplay } from './MultiplePointsDisplay';
import { PointsCellWrapper } from './PointsCellWrapper';
import { SinglePointDisplay } from './SinglePointDisplay';

type PointsCellProps = {
  points?: number | null;
  pointsOptions?: number[] | null;
  color: string;
};

export function PointsCell({ points, pointsOptions, color }: PointsCellProps) {
  const mode = getPointsDisplayMode(points, pointsOptions);
  const hasNoPointsData = mode === 'none';
  const hasSinglePointValue = mode === 'single';
  const hasMultiplePointOptions = mode === 'multiple';

  if (hasNoPointsData) {
    return <PointsCellWrapper />;
  }

  if (hasSinglePointValue) {
    // mode 'single' guarantees a truthy points value
    return <SinglePointDisplay point={points!} color={color} />;
  }

  if (hasMultiplePointOptions) {
    // mode 'multiple' guarantees a non-empty pointsOptions array
    return <MultiplePointsDisplay points={pointsOptions!} color={color} />;
  }

  return null;
}
